.panel {
  background: #fff;
  padding: 8px 0;
  font-size: 1rem;
  color: var(--color-ink);
}

.head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 0 0 18px;
}

.heading {
  font-family: var(--font-display);
  font-weight: 800;
  font-size: 1.6rem;
  letter-spacing: 0.06em;
  margin: 0;
}

.toggle {
  display: inline-flex;
  border: 1.5px solid var(--color-ink);
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
}

.toggleBtn {
  background: transparent;
  border: 0;
  padding: 8px 18px;
  font: inherit;
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  cursor: pointer;
  color: var(--color-ink);
  line-height: 1;
}

.toggleBtnActive {
  background: var(--color-ink);
  color: #fff;
}

.divider {
  height: 1px;
  background: rgba(0, 0, 0, 0.12);
  width: 100%;
}

.list {
  margin: 0;
  padding: 8px 0;
  display: flex;
  flex-direction: column;
}

.row {
  padding: 14px 0 16px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 2px;
}

.label {
  font-weight: 700;
  font-size: 1rem;
  margin: 0;
  color: var(--color-ink);
}

.value {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 300;
  letter-spacing: 0;
  color: var(--color-ink);
  line-height: 1.25;
}

.hint {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
  background: transparent;
  border: 0;
  padding: 0;
  font: inherit;
  font-size: 0.85rem;
  color: var(--color-ink-soft);
  cursor: pointer;
  text-align: left;
}

.hint:hover { color: var(--color-ink); }

.origin {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 22px 0 8px;
}

.originText {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.originText strong {
  font-size: 1rem;
  font-weight: 700;
}

.originNote {
  font-size: 0.85rem;
  color: var(--color-ink-soft);
  padding-left: 16px;
}

.originFlag {
  font-size: 2.4rem;
  line-height: 1;
}

@media (max-width: 768px) {
  .heading { font-size: 1.4rem; }
  .value { font-size: 1.15rem; }
  .toggleBtn { padding: 7px 14px; font-size: 0.8rem; }
}
